<template>
	<div class="pyBox" v-loading="loading" element-loading-text="听力拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<img src="@/assets/img/peiy.png" v-if="subtitlingUrl && videoUrl" @click.stop="pyBtn" class="pyImg" alt="" />
		<dubbingVideo
			ref="dubbRef"
			@fhFn="fhFn"
			@gbFn="dubFlag = false"
			v-if="subtitlingUrl"
			:currentTimes="currentTimes"
			:audioUrl="$httpUrl + audioUrl"
			:subtitlingUrl="$httpUrl + subtitlingUrl"
			:coverImg="coverImg ? $httpUrl + coverImg : null"
			:videoUrl="videoUrlCheck(videoUrl)"
			:dubFlag="dubFlag"
		/>
		<video
			ref="videoPlayer"
			class="video-js vjs-default-skin myVideo"
			controls
			preload="auto"
			:poster="coverImg ? $httpUrl + coverImg : null"
			width="640"
			v-if="vFlag"
			:height="height"
			data-setup="{}"
		>
			<source :src="videoSrc ? videoSrc : videoUrlCheck(videoUrl)" type="video/mp4" />
			<source :src="videoSrc ? videoSrc : videoUrlCheck(videoUrl)" type="video/mov" />
			<source :src="videoSrc ? videoSrc : videoUrlCheck(videoUrl)" type="video/flv" />
			<!-- 其他视频源 -->
		</video>
	</div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import dubbingVideo from '@/components/pubComponents/dubbingVideo';
import axios from 'axios';
import jsFileDownload from 'js-file-download';

export default {
	name: 'myVideo',
	data() {
		return {
			dubFlag: false,
			audioName: '',
			audioSrc: '',
			aFlag: true,
			videoName: '',
			videoSrc: '',
			vFlag: true,
			loading: false,
			vNliu: '',
			aNliu: '',
			currentTimes: 0
		};
	},
	props: {
		videoUrl: {
			type: String,
			default: ''
		},
		videoResourceFileId: {
			type: Number,
			default: 0
		},
		audioResourceFileId: {
			type: Number,
			default: 0
		},
		subtitlingUrl: {
			type: String,
			default: ''
		},
		audioUrl: {
			type: String,
			default: ''
		},
		coverImg: {
			type: String,
			default: ''
		},
		pyFlag: {
			type: String,
			default: ''
		},
		height: {
			default: '501',
			type: String
		}
	},
	components: {
		dubbingVideo
	},
	methods: {
		videoUrlCheck(url) {
			if (url.startsWith('http://') || url.startsWith('https://')) {
				return url
			} else {
				return this.$httpUrl + url
			}
		},
		pyBtn() {
			this.player.pause();
			const currentTimes = this.player.currentTime(); // 当前播放时间
			console.log(currentTimes, 7777);
			this.currentTimes = currentTimes;
			this.$nextTick(() => {
				this.$refs['dubbRef'].videoPlayer.currentTime = this.currentTimes;
			});
			this.dubFlag = true;
			this.$nextTick(() => {
				this.$refs['dubbRef'].dubFlag = true;
				this.$refs['dubbRef'].onFullScreen();
			});
		},
		fhFn() {
			this.dubFlag = false;
		},
		xzVideo() {
			if (this.vNliu) {
				jsFileDownload(this.vNliu, decodeURIComponent(this.videoName));
			}
		},
		xzAudio() {
			if (this.aNliu) {
				jsFileDownload(this.aNliu, decodeURIComponent(this.audioName));
			}
		}
	},
	mounted() {
		if (this.audioResourceFileId && this.subtitlingUrl) {
			this.aFlag = false;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: this.audioResourceFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.audioName = res.fileName;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								this.aNliu = res.data;
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								this.audioSrc = URL.createObjectURL(blob);
								this.aFlag = true;
							}
						});
					}
				});
		}
		if (this.videoResourceFileId) {
			this.loading = true;
			this.vFlag = false;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: this.videoResourceFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.videoName = res.fileName;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							this.loading = false;
							if (red && red.data) {
								this.vNliu = red.data;
								const blob = new Blob([red.data], { type: 'video/mpeg' });
								this.videoSrc = URL.createObjectURL(blob);
								this.vFlag = true;
							}
						});
					}
				});
		}
		this.$nextTick(() => {
			if (this.$refs.videoPlayer) {
				this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
					console.log('Player is ready');
				});
			}
		});
	},
	beforeDestroy() {
		if (this.player) {
			this.player.dispose();
		}
	}
};
</script>
<style lang="scss" scoped>
.myVideo {
	width: 100% !important;
	min-height: 501px;
	border-radius: 6px;
	margin-bottom: 23px;
}
.pyBox {
	position: relative;
	min-height: 501px;
	.pyImg {
		position: absolute;
		top: 20px;
		right: 30px;
		z-index: 99999;
		cursor: pointer;
	}
}
</style>
